import React, { useContext } from 'react';
import { Modal, Tabs, Typography, notification, Button, Table, Upload, Row, Col, Form, Radio, Input, Select, Spin } from 'antd';
import locale from 'antd/es/locale/pt_BR';
import {
    CloudUploadOutlined,
    InboxOutlined,
    CloseOutlined
} from '@ant-design/icons';
import Loading from '../../../../components/Loading';
import useCadastrar from './useCadastrar';
import { colInputs12 } from './GridStyled';
import { removeAcento } from '../../../../utils/RemoveAcentos';
import { ThemeContext } from '../../../../contexts/ThemeContext';

const { Text, Title } = Typography;
const mesesAbre = [
    {
        id: '01',
        mes: 'Janeiro',
    },
    {
        id: '02',
        mes: 'Fevereiro',
    },
    {
        id: '03',
        mes: 'Março',
    },
    {
        id: '04',
        mes: 'Abril',
    },
    {
        id: '05',
        mes: 'Maio',
    },
    {
        id: '06',
        mes: 'Junho',
    },
    {
        id: '07',
        mes: 'Julho',
    },
    {
        id: '08',
        mes: 'Agosto',
    },
    {
        id: '09',
        mes: 'Setembro',
    },
    {
        id: '10',
        mes: 'Outubro',
    },
    {
        id: '11',
        mes: 'Novembro',
    },
    {
        id: '12',
        mes: 'Dezembro',
    },
];

const CadastrarRecibos: React.FC = () => {

    const { theme } = useContext(ThemeContext);

    const {
        columns,
        dadosTabelaState,
        refContagemDoFiltro,
        loadingFormAdd,
        loadingTable,
        onclickTable,
        rowSelection,
        modalAddConfigVisible,
        clickBotaoAdd,
        clickBotaoEditar,
        hasSelectedAdd,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        refForm,
        loadingCidadesAndSetSelected,
        dadosCidadesSelect,
        gerarArrayAnos,
        onChangeMoney,
        valueRecibo,
    } = useCadastrar();

    return (
        <>
            <Row>
                <Col span={24}>
                    <Title level={3}>
                        {/* <IconCogs style={{ fontSize: 35 }} /> */}
                        Cadastrar Recibos
                    </Title>
                    {/* <Divider /> */}
                </Col>
            </Row>
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Button
                        type="primary"
                        loading={loadingTable}
                        disabled={!hasSelectedAdd}
                        onClick={clickBotaoAdd}
                        color='green'
                        variant='solid'
                        style={{
                            margin: 2
                        }}
                    >
                        Adicionar
                    </Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        color='orange'
                        variant='solid'
                        loading={loadingTable}
                        onClick={clickBotaoEditar}
                        disabled={hasSelectedAdd}
                        style={{
                            margin: 2
                        }}
                    >
                        Editar
                    </Button>
                    {/* {selectedRowKeys.length === 1 ?
                            ativarOuInativarModulo ?
                                <>
                                    <Popconfirm
                                        title="Deseja realmente inativar o modulo?"
                                        onConfirm={() => clickBotaoDeletarDados(false)}
                                        onCancel={() => { }}
                                        okText="Sim"
                                        cancelText="Não"
                                    >
                                        <Button className="botaoDeleteAssociacao" type="primary" danger
                                            // disabled={!hasSelectedDel}
                                            disabled={!hasSelectedEdit}
                                        >
                                            Inativar
                                        </Button>
                                    </Popconfirm>
                                </>
                                :
                                <>
                                    <Popconfirm
                                        title="Deseja realmente ativar modulo?"
                                        onConfirm={() => clickBotaoDeletarDados(true)}
                                        onCancel={() => { }}
                                        okText="Sim"
                                        cancelText="Não"
                                    >
                                        <Button className="botaoAtivarUsuario" type="primary"
                                            // disabled={!hasSelectedDel}
                                            disabled={!hasSelectedEdit}
                                        >
                                            Ativar
                                        </Button>
                                    </Popconfirm>
                                </>
                            :
                            <></>
                        } */}
                </Col>
            </Row>
            <Table
                loading={loadingTable}
                rowKey={(record) => record.id.toString()}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) }, // click row
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={dadosTabelaState}
                scroll={{ x: 1050 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {
                    return (
                        <div
                            style={{
                                backgroundColor:
                                    theme === "light"
                                        ? "#FAFAFA"
                                        : "#1D1D1D",
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5,
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length
                                    } de ${refContagemDoFiltro.current.length === 0
                                        ? dadosTabelaState.length
                                        : refContagemDoFiltro.current.length
                                    } num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    );
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: "end",
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length
                                    } de ${refContagemDoFiltro.current.length === 0
                                        ? dadosTabelaState.length
                                        : refContagemDoFiltro.current.length
                                    } num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    );
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: "" },
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    position: ["topRight", "bottomRight"],
                    pageSizeOptions: ["10", "20", "50", "100"],
                }}
                locale={locale.Table}
            />
            <Modal
                title="Adicionar Recibo"
                open={modalAddConfigVisible}
                width={850}
                onOk={clickSubmitModalAddConfig}
                onCancel={clickCancelModalAddConfig}
                destroyOnClose
                footer={[
                    <Button key="back" disabled={loadingFormAdd} onClick={clickCancelModalAddConfig}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingFormAdd} onClick={clickSubmitModalAddConfig}>
                        Salvar
                    </Button>,
                ]}
            >
                <Loading loading={loadingFormAdd}>
                    <Form
                        ref={refForm}
                        name="formModalAddAssociacao"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                        }}
                        onFinishFailed={() => { }}
                    >
                        <Row>
                            <Col {...colInputs12} hidden={!(typeof valueRecibo === 'string')}>
                                <Form.Item
                                    name="id_recibo"
                                    label="Id recibo"
                                    style={{ margin: 5 }}
                                    rules={[
                                        {
                                            required: false,
                                            message: "Por favor, preencha o id do recibo.",
                                        }
                                    ]}
                                >
                                    <Input placeholder="9999" />
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="siafi"
                                    label="SIAFI"
                                    style={{ margin: 5 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, preencha o siafi.",
                                        }
                                    ]}
                                >
                                    <Input placeholder="9999" />
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="cidades"
                                    label="Município"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, selecione um município.',
                                        },
                                    ]}
                                    style={{ margin: 5 }}
                                >
                                    <Select
                                        // ref={refFormModoEstadoSelect}
                                        loading={loadingCidadesAndSetSelected}
                                        notFoundContent={loadingCidadesAndSetSelected ? <Spin size="small" /> : null}
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione..."
                                        // mode="multiple"
                                        filterOption={(input: any, option: any) => {
                                            let textDigit = removeAcento(input)
                                            let listCidade = removeAcento(option?.children);
                                            return listCidade.indexOf(textDigit) >= 0
                                        }}
                                    >
                                        {
                                            dadosCidadesSelect.map((item) => {
                                                return (
                                                    <Select.Option
                                                        value={item.id}
                                                        key={item.id}
                                                    >
                                                        {item.nome + ' - ' + item.uf}
                                                    </Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="ano"
                                    label="Ano"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, selecione o ano.',
                                        },
                                    ]}
                                    style={{ margin: 5 }}
                                >
                                    <Select
                                        loading={loadingCidadesAndSetSelected}
                                        notFoundContent={loadingCidadesAndSetSelected ? <Spin size="small" /> : null}
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione..."
                                        // mode="multiple"
                                        filterOption={(input: any, option: any) => {
                                            let textDigit = removeAcento(String(input))
                                            let listCidade = removeAcento(String(option?.children));
                                            return listCidade.indexOf(textDigit) >= 0
                                        }}
                                    >
                                        {
                                            gerarArrayAnos().map((item) => {
                                                return (
                                                    <Select.Option
                                                        value={item.toString()}
                                                        key={item}
                                                    >
                                                        {item}
                                                    </Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="mes"
                                    label="Mês"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, selecione o mês.',
                                        },
                                    ]}
                                    style={{ margin: 5 }}
                                >
                                    <Select
                                        loading={loadingCidadesAndSetSelected}
                                        notFoundContent={loadingCidadesAndSetSelected ? <Spin size="small" /> : null}
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione..."
                                        // mode="multiple"
                                        filterOption={(input: any, option: any) => {
                                            let textDigit = removeAcento(input)
                                            let listCidade = removeAcento(option?.children);
                                            return listCidade.indexOf(textDigit) >= 0
                                        }}
                                    >
                                        {
                                            mesesAbre.map((item) => {
                                                return (
                                                    <Select.Option
                                                        value={item.id}
                                                        key={item.id}
                                                    >
                                                        {item.mes}
                                                    </Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="valor"
                                    label="Valor (R$)"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, digite o valor.",
                                        },
                                    ]}
                                    style={{ margin: 5 }}
                                >
                                    <Input
                                        onChange={(e) => onChangeMoney(e)}
                                        placeholder="0,00"
                                        maxLength={21}
                                    />
                                </Form.Item>
                            </Col>
                            <Col {...colInputs12}>
                                <Form.Item
                                    name="extenso"
                                    label="Valor Extenso"
                                    style={{ margin: 5 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, preencha o valor extenso.",
                                        }
                                    ]}
                                >
                                    <Input placeholder="Ex: Mil e seiscentos reais" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Loading>
            </Modal>
        </>
    );
}

export default CadastrarRecibos;
